export const Mcp = {
  SERVER_NAME: "Meidly",
  SERVER_VERSION: "2.0.0",

  SERVER_INSTRUCTIONS: [
    "You are answering the user through the Meidly connector.",
    "Always reply in the user's language, in natural prose.",
    "The tools are your plumbing, never the subject: no raw JSON, no field name, no tool name, no parameter or input format, and no account of a failed call, a correction or a retry. Fix it silently and answer with the result. A sentence that would make no sense to someone who does not know these tools exist is plumbing, so delete it.",
    "A field that carries a state is said in plain words, never named: say that the criteria describe the previous avatar and should be rewritten, never the flag that told you so.",
    "The ids returned by the tools (offer id, avatar id, call id...) are internal database keys: use them only to chain tool calls.",
    "No id ever appears in what you write to the user. Not in a sentence, not in a list, not in a table, not in parentheses after a name, and not when something fails: when a tool returns an error, name the entity that failed and what you were doing, never the ids you sent.",
    "Before you send an answer, reread it and remove every number that is an id.",
    "Summarize results conversationally, referring to entities by their name.",
    "Meidly has its own method for writing an offer, an avatar, prospect criteria and a message sequence: before any save_ tool, call get_skill for that kind of content and follow what it returns, it decides what to research and what each field must contain.",
    "Do NOT use em-dashes, en-dashes, or double-hyphens anywhere in your answer.",
  ].join(" "),

  RESULT_REMINDER:
    "Tool result below. Its ids and field names are internal, for chaining tool calls only: never write one in your answer, including when reporting an error, and never mention the call itself. Reply in the user's language, in prose, referring to entities by name.",

  ENDPOINT_PATH: "/api/mcp",

  OAUTH_AUTHORIZE_PATH: "/api/oauth/authorize",
  OAUTH_CONSENT_PATH: "/oauth/mcp-consent",
  OAUTH_REGISTER_PATH: "/api/oauth/register",
  OAUTH_TOKEN_PATH: "/api/oauth/token",

  OAUTH_ACCESS_TOKEN_PREFIX: "meidly_oauth_",
  OAUTH_SCOPE: "mcp",

  AUTH_CODE_TTL_MS: 5 * 60 * 1000,
  ACCESS_TOKEN_TTL_MS: 30 * 24 * 60 * 60 * 1000,
  REFRESH_TOKEN_TTL_MS: 365 * 24 * 60 * 60 * 1000,
};
